import * as React from 'react';
const Trash = (props) => (
  <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3.91406 0.921875C4.03125 0.664062 4.28906 0.5 4.57031 0.5H7.40625C7.6875 0.5 7.94531 0.664062 8.0625 0.921875L8.25 1.25H10.5C10.8984 1.25 11.25 1.60156 11.25 2C11.25 2.42188 10.8984 2.75 10.5 2.75H1.5C1.07812 2.75 0.75 2.42188 0.75 2C0.75 1.60156 1.07812 1.25 1.5 1.25H3.75L3.91406 0.921875ZM9.98438 11.4453C9.96094 12.0547 9.46875 12.5 8.85938 12.5H3.11719C2.50781 12.5 2.01562 12.0547 1.99219 11.4453L1.47656 3.5H10.5L9.98438 11.4453Z"
      fill="#D92D20"
    />
  </svg>
);
export default Trash;
